
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Select assets to move:</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <asset-picker [pageSize]="5" (onAssetSelected)="assetSelected($event)" (onChange)="setDirty()" [deviceRelocationId]="deviceRelocationId" [disableAll]="disableStep" [hiddenColumns]="['serialNumber', 'assetTag', 'orderNumber']"></asset-picker>
</div>